import {Flex, Text, Button, Center, Box} from '@chakra-ui/react';
import router from 'next/router';

export interface ProductIpoOpenFooterProps {
  collectors: number;
  price: string;
  link: string;
  color: string;
  currencySymbol: string;
  currencyPostFix: string;
  darkMode?: boolean;
  assetId?: string;
}

export const ProductIpoOpenFooter: React.FC<ProductIpoOpenFooterProps> = ({
  collectors,
  price,
  link,
  color,
  currencySymbol,
  currencyPostFix,
  darkMode = false,
  assetId,
}) => {
  // const {currency, currencyPostfix} = useGeolocation();
  return (
    <Box position="relative">
      <Center
        background={darkMode ? 'black' : 'white'}
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.1)"
        position="fixed"
        bottom="0"
        width="100%"
        zIndex="banner"
        py={2}
        borderTopRadius={{base: '14px', md: '0px'}}
      >
        <Flex
          width={assetId === 'valentines.day.mascara' ? '696px' : '600px'}
          justifyContent="space-between"
          alignItems="center"
        >
          <Text
            textStyle="button"
            fontSize="12px"
            lineHeight="16.8px"
            display={{base: 'none', md: 'block'}}
            color={darkMode ? 'white' : 'auto'}
          >
            {collectors} existing collector{collectors !== 1 ? 's' : ''}
          </Text>
          <Flex
            alignItems="center"
            display={{base: 'none', md: 'flex'}}
            px={assetId === 'valentines.day.mascara' ? '24px' : 0}
          >
            <Text
              textStyle="button"
              lineHeight="22.4px"
              color={darkMode ? 'white' : 'auto'}
            >
              Price per Piece{' '}
              {assetId === 'valentines.day.mascara' ? 'and benefits' : ''}
            </Text>
            <Text textStyle="h5" color={color} ml={3}>
              {currencySymbol}
              {price}
              {currencyPostFix}
            </Text>
          </Flex>
          <Box px={{base: '16px', md: '0'}} width={{base: '100%', md: 'auto'}}>
            <Button
              colorScheme="aqua"
              onClick={() => router.push(link)}
              p="9px 26px"
              width={{base: '100%', md: 'auto'}}
            >
              <Text textStyle="h7">Buy Pieces</Text>
            </Button>
          </Box>
        </Flex>
      </Center>
    </Box>
  );
};
